export default {
    date: {
        type: Date,
        default: new Date(),
    },
    type: {
        type: String,
        default: "attention",
        validator: (value) => {
            return (
                [
                    "attention",
                    "success",
                    "error",
                    "info",
                    "warning",
                    "neutral",
                ].indexOf(value) !== -1
            );
        },
    },
    icon: {
        type: [String, Object],
        default: "attention",
        validator: (value) => {
            return (
                [
                    "attention",
                    "cross",
                    "error",
                    "info",
                    "user",
                    "cart",
                    "check",
                    "success",
                    "delivery",
                ].indexOf(value) !== -1
            );
        },
    },
    color: {
        type: String,
        default: "#FAAD65",
    },
    text: {
        type: [String, Error, Object],
        default: "",
    },
    title: {
        type: [String, Object],
        default: "",
    },
    item: {
        type: Object,
        default: null,
    },
    duration: {
        type: Number,
    },
    withTimer: {
        type: Boolean,
        default: true,
    },
};
